import auth from "../Middlewares/auth";

import Empty from "../../Components/Pages/Empty";

export const routes = [
    {
        path: '/profile',
        name: 'profile',
        component: Empty,
        meta: {
            title: "Profile Settings",
            middleware: [
                auth
            ],
        }
    }
]
